/**
 * Rotas da aplicação centralizadas. Fonte única para navegação e
 * `routerLink`, evitando strings de rota espalhadas pelo código. Caminhos
 * são absolutos; funções constroem rotas parametrizadas.
 *
 * Uso:
 * - Navegação: `router.navigate([APP_ROUTES.accountManager.assistants])`.
 * - Parametrizada: `router.navigate([APP_ROUTES.conversation(id)])`.
 * - Template: exponha `protected readonly routes = APP_ROUTES;` e use
 *   `[routerLink]="routes.admin.organizations"`.
 */
export const APP_ROUTES = {
    home: '/home',
    noAssistant: '/home/no-assistant',
    selectAssistant: '/home/select-assistant',
    subscriptionInactive: '/home/subscription-inactive',
    conversation: (id: string): string => `/home/conversations/${id}`,
    selectOrganization: '/select-organization',
    accessForbidden: '/access-forbidden',
    docs: '/docs',
    accountManager: {
        root: '/account-manager',
        dashboard: '/account-manager/dashboard',
        assistants: '/account-manager/assistants',
        assistant: (id: string): string => `/account-manager/assistants/${id}`,
        datastores: '/account-manager/datastores',
        datastore: (id: string): string => `/account-manager/datastores/${id}`,
        datastoreSynchronization: (id: string): string =>
            `/account-manager/datastores/${id}/synchronization`,
        connectors: '/account-manager/connectors',
        connector: (id: string): string => `/account-manager/connectors/${id}`,
        membersGroups: '/account-manager/members-groups',
        users: '/account-manager/users',
        accountInformations: '/account-manager/account-informations',
    },
    organizationManager: {
        root: '/organization-manager',
        accounts: '/organization-manager/accounts',
        account: (id: string): string =>
            `/organization-manager/accounts/${id}`,
        users: '/organization-manager/users',
        orgInformations: '/organization-manager/org-informations',
        openAssistant: '/organization-manager/open-assistant',
        connectors: '/organization-manager/connectors',
        connector: (id: string): string =>
            `/organization-manager/connectors/${id}`,
    },
    admin: {
        root: '/admin',
        dashboard: '/admin/dashboard',
        organizations: '/admin/organizations',
        synchronizations: '/admin/synchronizations',
        connectorProviders: '/admin/connector-providers',
        connectorProvider: (id: string): string =>
            `/admin/connector-providers/${id}`,
        connectorTemplates: '/admin/connector-templates',
        connectorTemplate: (id: string): string =>
            `/admin/connector-templates/${id}`,
        models: '/admin/models',
        model: (id: string): string => `/admin/models/${id}`,
        connectors: '/admin/connectors',
        connector: (id: string): string => `/admin/connectors/${id}`,
    },
} as const;
